<button class="input-information" data-ignore-lint (click)="toggleActive()">
  <app-ice-info-icon />
  <span>{{ label }}</span>
</button>
